export default __webpack_public_path__ + "static/media/3109.68775442.jpg";